import { FC } from "react"
import { Flex } from "@mantine/core"
import { FilterDropdown } from "../FilterDropdown"
import { FilterRangeInput } from "../FilterRangeInput"
import { IFilterInput } from "../../lib/helpers/getFiltersInputs"
import { UseFormReturnType } from "@mantine/form"
import { FilterFormValues } from "../../lib"
import { useMediaQuery } from "@mantine/hooks"

interface FilterInputListProps {
	inputs: IFilterInput[]
	form: UseFormReturnType<FilterFormValues>
}

export const FilterInputList: FC<FilterInputListProps> = ({ inputs, form }) => {
	const isMobile = useMediaQuery("(max-width: 768px)")

	const inputList = inputs.map(item => {
		if (item.type === "options" && item.options) {
			return (
				<FilterDropdown
					key={item.name}
					name={item.name}
					label={item.label}
					options={item.options}
					form={form}
				/>
			)
		} else if (item.type === "range" && item.range) {
			return (
				<FilterRangeInput
					key={item.name}
					name={item.name}
					label={item.label}
					defaultValue={item.range.defaultValue || [0, 0]}
					form={form}
				/>
			)
		}

		return null
	})
	return (
		<Flex gap={32} w="100%" align="flex-start" wrap="wrap" direction={isMobile ? "column" : "row"}>
			{inputList}
		</Flex>
	)
}
